import options from './things-list.component';

export default {
    selector: 'dtThingsList',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-list/index.js